import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

import axios from "axios";

export default {
  namespaced: true,
  state: {
      lista: [],
      filtroAvancado: false,
      filtroCabecalho: false,
      perPage: 100,
      todos: false,
      descricao: null,
      id: null,
      centroEstoqueId : null,
      almoxarifado: '1',
      ean: null,
      cest: null,
      ncm: null,
      tipoId: null,
      grupoId: null,
      centroEstoqueId: null,
      registroSelecionadoId: null,
      paginaAtual: 1
      
      
  },
  getters: {
    LISTA: state => {return state.lista },
    FIELDS: state => {return state.fields },
    PER_PAGE: state => {return state.perPage },
    FILTRO_AVANCADO: state => {return state.filtroAvancado},
    FILTRO_CABECALHO: state => {return state.filtroCabecalho},
    TODOS: state => { return state.todos},
    ID: state => { return state.id},
    DESCRICAO: state => { return state.descricao},
    CENTRO_ESTOQUE_ID: state => { return state.centroEstoqueId},
    ALMOXARIFADO: state => { return state.almoxarifado},
    EAN: state => { return state.ean},
    NCM: state => { return state.ncm},
    CEST: state => { return state.cest},
    TIPO_ID: state => { return state.tipoId},
    GRUPO_ID: state => { return state.grupoId},
    REGISTRO_SELECIONADO_ID: state => { return state.registroSelecionadoId  },
    PAGINA_ATUAL: state => { return state.paginaAtual  }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => { state.lista = payload},
    SET_FIELDS: (state, payload) => { state.fields = payload},
    SET_PER_PAGE: (state, payload) => { state.perPage = payload},
    SET_FILTRO_AVANCADO: (state, payload) => {state.filtroAvancado = payload},
    SET_FILTRO_CABECALHO: (state, payload) => {state.filtroCabecalho = payload},
    SET_TODOS: state => { return state.todos},
    SET_ID: (state, payload) => {state.id = payload},
    SET_DESCRICAO: (state, payload) => {state.descricao = payload},
    SET_CENTRO_ESTOQUE_ID: (state, payload) => {state.centroEstoqueId = payload},
    SET_BENEFICIA: (state, payload) => {state.beneficia = payload},
    SET_BENEFICIADO: (state, payload) => {state.beneficiado = payload},
    SET_ALMOXARIFADO: (state, payload) => {state.almoxarifado = payload},
    SET_PERMITE_VENDA: (state, payload) => {state.permiteVenda = payload},
    SET_EAN: (state, payload) => {state.ean = payload},
    SET_NCM: (state, payload) => {state.ncm = payload},
    SET_CEST: (state, payload) => {state.cest = payload},
    SET_TIPO_ID: (state, payload) => {state.tipoId = payload},
    SET_GRUPO_ID: (state, payload) => {state.grupoId = payload},
    

    SET_REGISTRO_SELECIONADO_ID: (state, payload) => { state.registroSelecionadoId = payload  },
    SET_PAGINA_ATUAL: (state, payload) => { state.paginaAtual = payload },
    SET_LIMPAR: (state, payload) => {
        state.lista = [],
        state.filtroAvancado = false,
        state.todos = false,
        state.descricao = null,
        state.id = null,
        state.centroEstoqueId  = null,
        state.almoxarifado = '1',
        state.ean = null,
        state.cest = null,
        state.ncm = null,
        state.tipoId = null,
        state.grupoId = null,
        state.centroEstoqueId = null,
        state.registroSelecionadoId = null,
        state.paginaAtual = 1
    },
    SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
        state.filtroAvancado = false,
        state.todos = false,
        state.descricao = null,
        state.id = null,
        state.centroEstoqueId  = null,
        state.almoxarifado = '1',
        state.ean = null,
        state.cest = null,
        state.ncm = null,
        state.tipoId = null,
        state.grupoId = null,
        state.centroEstoqueId = null,
        state.paginaAtual = 1
    }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
            // Monte um objeto com todos os possíveis filtros
            const filtros = {
                todos: getters.TODOS,
                id: getters.ID,
                descricao: getters.DESCRICAO,
                centroEstoqueId: getters.CENTRO_ESTOQUE_ID,
                almoxarifado: getters.ALMOXARIFADO,
                ean: getters.EAN,
                cest: getters.CEST,
                ncm: getters.NCM,
                tipoId: getters.TIPO_ID,
                grupoId: getters.GRUPO_ID,
                pagina: getters.PAGINA_ATUAL
            }

            axios
                .post('/api/protected/produto/pesquisar', filtros)
                .then(({ data, status }) => {
                    if (!skipConfirmation && data.length > LIMITE_REGISTROS_PESQUISA) {
                        resolve({ data, status, needsConfirmation: true, count: data.length });
                        return;
                    }
                    commit("SET_LISTA", data);
                    if (status === 200 || status === 201) {
                        resolve({ data, status, needsConfirmation: false });
                    }
                })
                .catch(error => {
                  reject(error)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/bens-store.js